// Tooltips are tippy instances on `.tooltip` elements. tippy comes from the CDN script the layouts
// load, so these do nothing on a page without it.
const tippyLoaded = () => typeof window.tippy === 'function';

// Accepts a single element node, a collection of nodes or a jQuery object
const elementsOf = ($el) =>
  $el instanceof NodeList ? $el : $el instanceof Element ? [$el] : Array.from($el);

export const initTooltips = ($el) => {
  if (!tippyLoaded()) {
    return;
  }

  const elements = elementsOf($el);

  elements.forEach((element) => {
    // Destroy existing tippy instance
    if (element._tippy) {
      element._tippy.destroy();
    }

    // Create tippy instance
    if (element.classList.contains('tooltip')) {
      const tooltipContent = element.querySelector('.tooltip__content');
      const maxWidth = tooltipContent?.dataset?.maxWidth;
      let tooltipPlacement = 'top';

      switch (true) {
        case element.classList.contains('tooltip--bottom'):
          tooltipPlacement = 'bottom';
          break;
        case element.classList.contains('tooltip--bottom-left'):
          tooltipPlacement = 'bottom-start';
          break;
        case element.classList.contains('tooltip--bottom-right'):
          tooltipPlacement = 'bottom-end';
          break;
        case element.classList.contains('tooltip--right'):
          tooltipPlacement = 'right';
          break;
      }

      if (tooltipContent) {
        window.tippy(element, {
          content: element.querySelector('.tooltip__content').innerHTML,
          allowHTML: true,
          touch: element.classList.contains('tooltip--on-click'),
          interactive: element.classList.contains('tooltip--interactive'),
          trigger: element.classList.contains('tooltip--on-click') ? 'click' : 'mouseenter focus',
          showOnCreate: element.classList.contains('tooltip--active'),
          theme: element.dataset.tooltipTheme,
          placement: tooltipPlacement,
          hideOnClick:
            element.classList.contains('tooltip--on-click') &&
            element.classList.contains('tooltip--persist')
              ? 'toggle'
              : element.classList.contains('tooltip--persist')
                ? false
                : true,
          appendTo: element.closest('dialog') || document.body,
          maxWidth: maxWidth || 288,
          offset: [0, 8],
          zIndex: element.classList.contains('tooltip--active') ? 6 : 9999,
          arrow:
            '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>',
          onShow(instance) {
            if (element.classList.contains('tooltip--on-click')) {
              const closeButton = instance.popper.querySelector('.tooltip__close');
              if (closeButton) {
                closeButton.addEventListener('click', () => {
                  instance.hide();
                });
              }
            }
            if (element.classList.contains('tooltip--auto-hide')) {
              setTimeout(() => {
                instance.hide();
              }, 2000);
            }
          },
          onHide(instance) {
            if (element.classList.contains('tooltip--on-click')) {
              const closeButton = instance.popper.querySelector('.tooltip__close');
              if (closeButton) {
                closeButton.removeEventListener('click', () => {
                  instance.hide();
                });
              }
            }
          },
        });
      }
    }
  });
};

export const destroyTooltips = ($el) => {
  if (!tippyLoaded()) {
    return;
  }

  elementsOf($el).forEach((element) => {
    window.tippy(element).destroy();
  });
};

export const updateTooltipContent = ($el, content) => {
  const element = $el?.jquery ? $el[0] : $el;

  if (element instanceof Element && element._tippy) {
    element._tippy.setContent(content);
  }
};
